module.exports = __webpack_public_path__ + "img/empty-birthday-offer-1.3867f4aa.png";